// removed by extract-text-webpack-plugin
module.exports = {"theme":"var(--theme-color, #c74411)","themeBg":"#fdf9f5","textColor":"var(--textColor-color, #c74411)","subTextColor":"#999","activeColor":"#fff","bodyBg":"var(--bodyBg-color, #fff0e4)"};


//////////////////
// WEBPACK FOOTER
// ./src/style/index.scss
// module id = +qiL
// module chunks = 26